(function () {
  function mainSubmitInert(mainBtn) {
    if (!mainBtn) return true;
    return mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
  }

  function isSubtreeVisible(el, root) {
    let node = el;
    while (node) {
      const st = window.getComputedStyle(node);
      if (st.display === 'none' || st.visibility === 'hidden') return false;
      if (node === root) return true;
      node = node.parentElement;
    }
    return false;
  }

  function getVisiblePriceFigureText(priceRoot) {
    if (!priceRoot || !priceRoot.isConnected) return '';

    const tryText = function (selector) {
      const el = priceRoot.querySelector(selector);
      if (!el || el.closest('s')) return '';
      if (!isSubtreeVisible(el, priceRoot)) return '';
      return el.textContent.replace(/\s+/g, ' ').trim();
    };

    const fromAppstle = tryText('.appstle_subscription_final_price');
    if (fromAppstle) return fromAppstle;

    const fromLast = tryText('.price-item--last');
    if (fromLast) return fromLast;

    const fromRegular = tryText('.price__regular .price-item--regular');
    if (fromRegular) return fromRegular;

    return '';
  }

  function syncFloatingAtc(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    const floatingBtn = root.querySelector('[data-floating-atc-submit]');
    const mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!floatingBtn) return;

    const visible = floatingBtn.querySelector('.relab-card__cta-visible');
    const priceSlot = root.querySelector('[data-floating-atc-btn-price]');
    const labelEl = root.querySelector('[data-floating-atc-label]');
    const sep = floatingBtn.querySelector('.relab-card__cta-sep');
    const mid = floatingBtn.querySelector('.relab-card__cta-mid');

    const mainVisible = mainBtn?.querySelector('.relab-card__cta-visible');
    const mainLabel = mainBtn?.querySelector('.relab-card__cta-label');
    const mainPrice = mainBtn?.querySelector('.relab-card__cta-price');
    const mainPriceBlock = document.getElementById('price-' + sectionId);

    if (mainLabel && labelEl) {
      labelEl.textContent = mainLabel.textContent.replace(/\s+/g, ' ').trim();
    }

    if (priceSlot) {
      const nextPrice =
        mainPrice?.textContent?.replace(/\s+/g, ' ').trim() ||
        getVisiblePriceFigureText(mainPriceBlock);
      priceSlot.textContent = nextPrice;
    }

    if (visible && mainVisible) {
      const soldOut = mainVisible.classList.contains('relab-card__cta-visible--sold-out');
      visible.classList.toggle('relab-card__cta-visible--sold-out', soldOut);
      if (soldOut) {
        priceSlot?.classList.add('hidden');
        sep?.classList.add('hidden');
        mid?.classList.add('hidden');
      } else {
        priceSlot?.classList.remove('hidden');
        sep?.classList.remove('hidden');
        mid?.classList.remove('hidden');
      }
    }

    if (mainBtn) {
      const inert = mainSubmitInert(mainBtn);
      floatingBtn.disabled = inert;
      if (inert) {
        floatingBtn.setAttribute('aria-disabled', 'true');
      } else {
        floatingBtn.removeAttribute('aria-disabled');
      }
    }
  }

  function initFloatingAtcVisibility(root, mainBtn) {
    const setVisible = function (show) {
      root.classList.toggle('is-visible', show);
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    if (!mainBtn) {
      setVisible(false);
      return;
    }

    setVisible(false);

    const observer = new IntersectionObserver(
      function (entries) {
        const entry = entries[0];
        if (!entry) return;
        const scrolledPast =
          !entry.isIntersecting && entry.boundingClientRect.top < 0;
        setVisible(scrolledPast);
      },
      { threshold: 0 }
    );

    observer.observe(mainBtn);
  }

  function initFloatingAtc(root) {
    if (root.dataset.floatingAtcInit === '1') return;
    root.dataset.floatingAtcInit = '1';

    const sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    const floatingBtn = root.querySelector('[data-floating-atc-submit]');
    const mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);

    initFloatingAtcVisibility(root, mainBtn);

    if (floatingBtn) {
      floatingBtn.addEventListener('click', function (e) {
        const mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
        if (!mainBtn || mainSubmitInert(mainBtn)) {
          e.preventDefault();
          return;
        }
        e.preventDefault();
        mainBtn.click();
      });
    }

    function scheduleSync() {
      window.requestAnimationFrame(function () {
        syncFloatingAtc(root);
      });
    }

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        if (!payload || !payload.data) return;
        if (String(payload.data.sectionId) !== String(sectionId)) return;
        scheduleSync();
      });
    }

    if (mainBtn) {
      const obs = new MutationObserver(scheduleSync);
      obs.observe(mainBtn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    const priceBlock = document.getElementById('price-' + sectionId);
    if (priceBlock) {
      const priceObs = new MutationObserver(scheduleSync);
      priceObs.observe(priceBlock, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleSync);
    } else {
      scheduleSync();
    }
  }

  document.querySelectorAll('[data-floating-atc]').forEach(initFloatingAtc);
})();
